import {createStore} from 'vuex';
import AuthModule from './modules/auth';
import AppModule from './modules/app';
import CustomerModule from './modules/customer';
import WarehouseModule from './modules/warehouse';
import CustomerCarModule from './modules/customerCar';
import OrderModule from './modules/order';
import AdminModule from './modules/admin';
import ReportModule from './modules/report';
import CarModule from './modules/car';
import ShopModule from './modules/shop';
import MessageModule from './modules/message';
import MissionModule from './modules/mission';
import CommissionModule from './modules/commission';
import address from "@/store/modules/address";
import incoming from "@/store/modules/incoming";

const store = createStore({
  modules:{
    auth:AuthModule,
    warehouse:WarehouseModule,
    app:AppModule,
    car:CarModule,
    customer : CustomerModule,
    order : OrderModule,
    customerCar : CustomerCarModule,
    admin : AdminModule,
    report : ReportModule,
    shop: ShopModule,
    message: MessageModule,
    mission: MissionModule,
    commission: CommissionModule,
    incoming: incoming,
    address : address
  }
});

export default store;